import { Promise } from 'bluebird'
import httpRequest from './httpRequest'

const api = '/api'
const version = '/1.0.0'

const prefix = api + version
const routeStats = version + '/stats/'
const routeActive = version + '/applianceactive/'
const routeDetails = version + '/appliancedetail/'
const routeLicenses = version + '/appliance-license/'

const routeCustomer = prefix + '/customer'
const routeCustomerSerials = routeCustomer + '/serials'

const routeEvent = prefix + '/applianceevent'

const routeApplianceTrack = prefix + '/appliancetrack'

const routeAggregates = prefix + '/agg'
const routeApplianceTotal = routeAggregates + '/appliancetotal'
const routeSoftwareVersion = routeAggregates + '/softwareversion'
const routeTrackIp = routeAggregates + '/track-ip'
const routeProxyProtocolStats = routeAggregates + '/proxyprotocolstat'

const routeGeoIp = prefix + '/geoip'

function plugin (Vue) {
  if (plugin.installed) {
    return
  }

  const apiWsoc = new Vue({
    methods: {
      geoIpLookup (ipAddresses) {
        var url = routeGeoIp
        url += httpRequest.queryStringWithAuth()
        return httpRequest.post(url, ipAddresses, this.$redirectLogin)
      },

      fetchStats (serial, epochStart, epochEnd) {
        var url = api + routeStats + serial
        var queryObj = {
          epochStart: epochStart,
          epochEnd: epochEnd
        }
        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchActiveSerials () {
        var url = routeActive
        url += httpRequest.queryStringWithAuth()
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchDetails (serial, epochStart, epochEnd) {
        var url = api + routeDetails + (serial || '')
        var queryObj = {
          epochStart: epochStart,
          epochEnd: epochEnd
        }
        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchLicenses (serial, epochStart, epochEnd) {
        var url = api + routeLicenses + (serial || '')
        var queryObj = {
          epochStart: epochStart,
          epochEnd: epochEnd
        }
        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchCustomers () {
        var url = routeCustomer
        url += httpRequest.queryStringWithAuth()
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchCustomerSerials () {
        var url = routeCustomerSerials
        url += httpRequest.queryStringWithAuth()
        return httpRequest.get(url, this.$redirectLogin)
      },

      // epochEnd must be accompanied by epochStart
      fetchTrack (serial, epochStart, epochEnd) {
        var url = routeApplianceTrack + '/' + serial
        var queryObj = {
          epochStart: epochStart,
          epochEnd: epochEnd
        }
        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchEvents (serial, epochStart, epochEnd) {
        var url = routeEvent + '/' + serial
        var queryObj = {
          epochStart: epochStart,
          epochEnd: epochEnd
        }
        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchTotalAppliance (start, end) {
        var url = routeApplianceTotal
        var queryObj = {
          start: start,
          end: end
        }

        if (!start || !end) {
          return Promise.reject('all of start and end are required')
        }

        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchSoftwareVersions (start, end) {
        var url = routeSoftwareVersion
        var queryObj = {
          start: start,
          end: end
        }

        if (!start || !end) {
          return Promise.reject('all of start and end are required')
        }

        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchTrackIp (start, end) {
        var url = routeTrackIp
        var queryObj = {
          start: start,
          end: end
        }

        if (!start || !end) {
          return Promise.reject('all of start and end are required')
        }

        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      },

      fetchProxyProtocolStats (start, end) {
        var url = routeProxyProtocolStats
        var queryObj = {
          start: start,
          end: end
        }

        if (!start || !end) {
          return Promise.reject('all of start and end are required')
        }

        url += httpRequest.queryStringWithAuth(queryObj)
        return httpRequest.get(url, this.$redirectLogin)
      }
    }
  })

  Object.defineProperty(Vue.prototype, '$apiWsoc', {
    get () {
      return apiWsoc
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/apiWsoc.js